import type { AxiosResponse } from "axios";
import { ApiInstance } from "@/api";

export default class PARTNER_API {
  static async patchPartner(
    inn: string,
    organisation: string,
  ): Promise<AxiosResponse> {
    return ApiInstance.patch(
      `/Partner?inn=${inn}&organisation=${organisation}`,
    );
  }

  static async getBrandsPartner(): Promise<AxiosResponse<string[]>> {
    return ApiInstance.get<string[]>("/Partner/Brands");
  }

  static async hasPartnerProducts(): Promise<AxiosResponse<boolean>> {
    return ApiInstance.get<boolean>("/Partner/Products");
  }

  static async setSyncResidues(
    syncResidues: boolean,
  ): Promise<AxiosResponse<boolean>> {
    return ApiInstance.patch(
      `/Partner/SyncResidues/?syncResidues=${syncResidues}`,
    );
  }

  static async setAllSyncResidues(config: {
    syncResidues?: boolean | null;
    syncResidues2?: number | null;
    isSyncResidues2Enable?: boolean | null;
    syncResidues3?: number | null;
    isSyncResidues3Enable?: boolean | null;
  }): Promise<AxiosResponse<boolean>> {
    return ApiInstance.patch("/Partner/AllSyncResidues", config);
  }

  static async changeImage(
    image: File | null,
  ): Promise<AxiosResponse<boolean>> {
    const formData = new FormData();

    formData.append("image", image || "");

    return ApiInstance.patch("/Partner/image", formData);
  }
}
